// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root___7a4j","empty":"ModalGraph_empty__29RJU"};